export default function createReducer(initialState, handlers) {
	return function reducer(currentState = initialState, action) {
		if (handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](currentState, action);
		} else {
			return currentState;
		}
	}
}